import React, { FocusEvent } from "react";
import { useField, useFormikContext } from "formik";
import FormItem, { FormItemProps } from "./FormItem";

type TextFormItemProps = Pick<FormItemProps, "label" | "name" | "style"> & {
  readonly type?: "text" | "password";
  readonly autoFocus?: boolean;
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly autoComplete?: HTMLInputElement["autocomplete"];
};

function TextFormItem({
  name,
  placeholder,
  autoComplete,
  autoFocus,
  type,
  style,
  disabled,
  label,
}: TextFormItemProps) {
  const [{ onBlur: formikOnBlur, ...field }] = useField<string>(name);
  const { isSubmitting } = useFormikContext();
  const fieldId = `${name}Field`;

  const onBlur = (e: FocusEvent<any>) => {
    // See https://github.com/formium/formik/issues/2062
    // i.e. this is to support autofocus
    const relatedTarget = e.relatedTarget;
    if (
      relatedTarget &&
      "tagName" in relatedTarget &&
      ((relatedTarget as Element).tagName === "A" ||
        (relatedTarget as Element).tagName === "BUTTON" ||
        (relatedTarget as Element).tagName === "INPUT")
    ) {
      return;
    }

    formikOnBlur(e);
  };

  return (
    <FormItem name={name} label={label} fieldId={fieldId} style={style}>
      <input
        id={fieldId}
        type={type}
        disabled={disabled || isSubmitting}
        className="input"
        placeholder={placeholder}
        onBlur={onBlur}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        {...field}
      />
    </FormItem>
  );
}

export default TextFormItem;
